// Paths that carry a live capability (Guest Management Link token, public payment id) must never reach logs.
export const redactCapabilityPath = (pathname: string): string =>
    pathname
        .replace(/^\/r\/[^/]+(?=\/|$)/, '/r/[token]')
        .replace(/^\/api\/public\/guest-bookings\/manage\/[^/]+(?=\/|$)/, '/api/public/guest-bookings/manage/[token]')
        .replace(/^\/platnosc\/[^/]+(?=\/|$)/, '/platnosc/[id]')
